/* 🤖 this file was generated by svg-to-ts */
export const matIconMinimize: {
  name: 'minimize';
  data: string;
} = {
  name: 'minimize',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M6 19h12v2H6v-2z"/></svg>`
};
